import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { VisitsContainer } from '@/features/visitors/containers';
import { meilisearchSearchSchema } from '@/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute('/_layout/visits/')({
  component: VisitsContainer,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
